import React, { ChangeEvent } from 'react';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import * as Inovx from '@shared';
import ConfigurationField from './ConfigurationField';
import { IConfigurationTreeNode } from './types';
import AssetSetTaxonomyTree from './AssetSetTaxonomyTree';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

declare var InovxLoader: any;

export interface GeneralConfigurationSectionProps {
    node: IConfigurationTreeNode;
    schemaUsageList: Array<{ text: string; id: string }>;
    schemaExtensionParentNames: string[];
    editableSchemaName: string;
    hasSchemaNameError: boolean;
    onSchemaNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
    assetSetTaxonomyDetail: ILibraryTaxonomyDetail | null;
    onAssetSetTaxonomyChange: (taxonomy: ILibraryTaxonomyDetail) => void;
    assetSetTaxonomyResetToken: number;
}

const GeneralConfigurationSection: React.FC<GeneralConfigurationSectionProps> = ({
    node,
    schemaUsageList,
    schemaExtensionParentNames,
    editableSchemaName,
    hasSchemaNameError,
    onSchemaNameChange,
    assetSetTaxonomyDetail,
    onAssetSetTaxonomyChange,
    assetSetTaxonomyResetToken
}) => {
    const iconUrl = `${UrlUtilities.getBaseApplicationUrl()}/images/schema/${node.IconFileName}`;

    return (
        <div className="configuration-form-details">
            <div className="configuration-form-detail-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <img src={iconUrl} alt={node.NodeType} style={{ width: 28, height: 28 }} />
                    <div>
                        <div className="configuration-form-title">{node.NodeType === 'schema' ? `${InovxLoader.t('facility:form.schema')} - ` : `${InovxLoader.t('facility:form.subSchema')} - `}<span className="text-bold">{node.Name}</span></div>
                    </div>
                </div>
            </div>
            <div>
                <div className="row d-flex">
                    <div className="col-md-12 field-col">
                        <ConfigurationField title={node.NodeType === 'schema' ? InovxLoader.t('facility:form.schemaName') : InovxLoader.t('facility:form.subSchemaName')} inputName="SelectedSchemaName" className={hasSchemaNameError ? 'has-error' : ''}>
                            <input
                                className="form-control responsive-control"
                                value={editableSchemaName}
                                onChange={onSchemaNameChange}
                                name="SelectedSchemaName"
                                placeholder={node.NodeType === 'schema' ? InovxLoader.t('facility:form.schemaNamePlaceholder') : InovxLoader.t('facility:form.schemaExtensionNamePlaceholder')}
                                autoComplete="off"
                                readOnly={node.NodeType === 'schema'}
                            />
                        </ConfigurationField>
                    </div>
                </div>

                {node.NodeType === 'schemaExtension' && (
                    <>
                        <div className="row d-flex mt-1">
                            <div className="col-md-12 field-col">
                                <ConfigurationField title={InovxLoader.t('facility:form.primarySchemaName')} inputName="SchemaParents">
                                    <input className="form-control responsive-control" value={schemaExtensionParentNames.join(', ')} readOnly />
                                </ConfigurationField>
                            </div>
                        </div>
                    </>
                )}

                <div className="row d-flex mt-1">
                    <div className="col-md-12 taxonomy-wrapper">
                        <AssetSetTaxonomyTree
                            key={`${assetSetTaxonomyDetail?.ID || 'empty'}-${assetSetTaxonomyResetToken}`}
                            taxonomy={assetSetTaxonomyDetail}
                            onChange={onAssetSetTaxonomyChange}
                            resetToken={assetSetTaxonomyResetToken}
                        />
                    </div>
                </div>
                
                <div className="configuration-form-facility-list mt-1">
                    <div className="row d-flex">
                        <div className="col-md-12 p-2">
                            <div className="d-flex j-csb a-ic">
                                <div className="ctm-control-label"><b>{InovxLoader.t('facility:form.facilityList')}</b> - {node.NodeType === 'schema' ? InovxLoader.t('facility:form.listTheFacilitiesThatUseThisSchema') : InovxLoader.t('facility:form.listTheFacilitiesThatUseThisSchemaExtension')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex">
                        <div className="col-md-12 field-col responsive-facility-list">
                            <ListViewComponent height={220} readOnly={true} disabled={true} id="facility-list-flat" dataSource={schemaUsageList} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralConfigurationSection;
